// src/lib/find-schema-definition.ts
import jsonpointer from "jsonpointer";
function findSchemaDefinition($ref, definition = {}) {
  let currRef = $ref.trim();
  if (currRef === "") {
    return false;
  }
  if (currRef.startsWith("#")) {
    currRef = decodeURIComponent(currRef.substring(1));
  } else {
    throw new Error(`Could not find a definition for ${$ref}.`);
  }
  const current = jsonpointer.get(definition, currRef);
  if (current === void 0) {
    throw new Error(`Could not find a definition for ${$ref}.`);
  }
  return current;
}

// src/utils.ts
var supportedMethods = ["get", "put", "post", "delete", "options", "head", "patch", "trace"];

export {
  findSchemaDefinition,
  supportedMethods
};
//# sourceMappingURL=chunk-W3LSKLU6.js.map